import { render, staticRenderFns } from "./AddTag.vue?vue&type=template&id=0344acbe&scoped=true&"
import script from "./AddTag.vue?vue&type=script&lang=ts&"
export * from "./AddTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344acbe",
  null
  
)

export default component.exports